angular.module('internal.forgotpassword',[])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('internal.forgotpassword', {
            url: '/forgotpassword',
            views: {
                'content': {
                    templateUrl: 'js/internal/forgot-password/forgot-password.view.html',
                    controller:'forgotPasswordCtrl'
                }
            }
        });
    }]);